webpackJsonp([182430388671878],{

/***/ 1635:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"AccountCreditItemEdge","kind":"OBJECT","type":"OBJECT","fields":[{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"cursor","type":{"kind":"SCALAR","name":"String","ofType":null}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"node","type":{"kind":"OBJECT","name":"AccountCreditItem","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---object-account-credit-item-edge-a91826c394005fc3dc54.js